import comp from "./MoreItemWithToolTipV2";
export default comp;
